import { useMemo, useRef, useState } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import LoadingOverlay from "src/components/common/form/LoadingOverlay";
import { Message } from "src/components/common/form/Message";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import useUiuxStore from "src/store/useUiuxStore";


import { useMouseContent } from "src/utils/mouse/mouseContent";

import { Content_WMS1030_R01 } from "./Content_WMS1030_R01";
import { Info_WMS1030_R01 } from "./Info_WMS1030_R01";
import { useWMS1030_R01Store } from "./Store_WMS1030_R01";
import { AgGridReact } from "ag-grid-react";
import { WMS1030_R01DetailDto, WMS1030_R01Dto, WMS1030_R01HeaderDto, WMS1030_R01LotDto } from "./Dto_WMS1030_R01";
import SearchSection_WMS1030_R01 from "./SearchSection_WMS1030_R01";
import { Table_WMS1030_R01 } from "./Table_WMS1030_R01";
import { DetailTable_WMS1030_R01 } from "./DetailTable_WMS1030_R01";
import { LotTable_WMS1030_R01 } from "./LotTable_WMS1030_R01";
import { SmallTitleSpan } from "src/components/common/common";


export const Container_WMS1030_R01 = () => {

	const { 
		syncInitialData,
	} = useWMS1030_R01Store();

	
	const { moneyCdList, vatTypeList } = useCommonCodeStore();
	const { tabList, setMessage } = useUiuxStore();


	const RESIZER = {
		code: 'WMS1030_R01',
		type: 'width',
		storageKey: 'WMS1030_R01-split-width',
		min: 5,
		max: 80,
		default: 45
	} as const;
	const gridRef = useRef<AgGridReact<WMS1030_R01HeaderDto>>(null);
	const lotGridRef = useRef<AgGridReact<WMS1030_R01LotDto>>(null);
	const detailGridRef = useRef<AgGridReact<WMS1030_R01DetailDto>>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	

	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});

	const V_RESIZER = {
		code: 'WMS1030_R01',
		type: 'height',
		storageKey: 'WMS1030_R01-info-split-height',
		min: 5,
		max: 80,
		default: 40
	} as const;
	const rightTopRef = useRef<HTMLDivElement>(null);
	const isVResizing = useRef(false);

	const { 
		splitValue: vSplitValue,
		handleMouseDown: handleVMouseDown,
	} = useMouseContent({
		resizer: V_RESIZER,
		isResizing: isVResizing,
		containerRef: infoRef,
		infoRef: rightTopRef
	});

	const RESIZER_LOT = {
		code: 'WMS1030_R01_lot',
		type: 'width',
		storageKey: 'WMS1030_R01-lot-split-width',
		min: 5,
		max: 80,
		default: 70
	} as const;
	const lotInfoRef = useRef<HTMLDivElement>(null);
	const isLotResizing = useRef(false);
	const [clickable, setClickable] = useState(false);

	const { 
		splitValue: lotSplitValue,
		handleMouseDown: handleLotMouseDown,
	} = useMouseContent({
		resizer: RESIZER_LOT,
		isResizing: isLotResizing,
		containerRef: infoRef,
		infoRef: lotInfoRef
	});

	const {
		handleExcelClick,
		fetchData,
		defaultWMS1030_R01HeaderRow,
		defaultWMS1030_R01DetailRow,
		defaultWMS1030_R01LotRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
		handleDetailInfoCode,
		handleFetchDetailList,
		handleFetchLotList,
	} = Content_WMS1030_R01({
		gridRef,
		detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
		
	});

	useMemo(() => { syncInitialData(); }, []);

	return <div className={`content-container`}>
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleCreateClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onPrintClick={() => {}}
			onExcelClick={handleExcelClick}
			onInitClick={initContainerData}
		/>
		<SearchSection_WMS1030_R01 onEnterKeyDown={() => { fetchData(); }} />

		<div className="flex flex-1 p-[12px] gap-[4px] min-h-0"
			ref={containerRef}>
			<div className="h-full" style={{ width: `${splitValue}%` }}>
				<Table_WMS1030_R01 gridRef={gridRef} handleCreateClick={handleCreateClick} defaultWMS1030_R01HeaderRow={defaultWMS1030_R01HeaderRow()} />
			</div>
			{/* 리사이저 */}
			<div
				className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
				onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
				data-comment="리사이저"
			/>
			<div className="h-full flex flex-col gap-[4px]" style={{ width: `${100 - splitValue}%` }} ref={infoRef}>
				<div style={{ height: `${vSplitValue}%`, maxHeight: `${vSplitValue}%` }} ref={rightTopRef}>
					<Info_WMS1030_R01 
						defaultWMS1030_R01HeaderRow={defaultWMS1030_R01HeaderRow()}
						handleDetailInfoCode={handleDetailInfoCode}
						handleFetchDetailList={handleFetchDetailList}
					/>
				</div>
				{/* 리사이저 */}
				<div
					className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
					onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleVMouseDown("UD", e.nativeEvent) }
				/>
				<div style={{ height: `${100 - vSplitValue}%` }} className="pb-[12px] flex flex-1 gap-[4px] min-w-0">
					<div className="h-full" style={{ width: `${lotSplitValue}%` }} ref={lotInfoRef}>
						<DetailTable_WMS1030_R01 
							detailGridRef={detailGridRef} 
							defaultWMS1030_R01DetailRow={defaultWMS1030_R01DetailRow()}
						/>
					</div>
					{/* 리사이저 */}
					<div
						className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300 h-full"
						onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleLotMouseDown('LR', e.nativeEvent)}
						data-comment="리사이저"
					/>
					<div className="h-full flex flex-col gap-[4px]" style={{ width: `${100 - lotSplitValue}%` }}>
						<SmallTitleSpan> Lot 출고 입력 </SmallTitleSpan>
						<LotTable_WMS1030_R01 lotGridRef={lotGridRef} defaultWMS1030_R01LotRow={defaultWMS1030_R01LotRow()} clickable={clickable} setClickable={setClickable}/>
					</div>
				</div>
			</div>
		</div>
		<Message />
	</div>
}